export default __webpack_public_path__ + "static/media/think-out-of-the-box.edd04b3c.md";